import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const StyledAppointmentCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.secondary || '#FFF3E0',
  borderRadius: '8px',
  padding: theme.spacing(1.7),
  marginBottom: theme.spacing(1.5),
}))

export const AppointmentDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  width: '100%',
}))

export const AppointmentInfo = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}))

export const AppointmentFirstRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '200px minmax(120px, 1fr) minmax(120px, 1fr)',
  alignItems: 'center',
  justifyItems: 'start',
  columnGap: theme.spacing(3),
  rowGap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '220px minmax(120px, 1fr) minmax(120px, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(0),
  },
}))

export const AppointmentLocationField = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.text.primary,
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'normal',
  },
}))
